import { EmeraldIcon } from "@emerald-react/icon";

type SelectedPinInfo = {
  numbers: number[];
  ids: string[];
  type: string;
} | null;

const bannerConfig = {
  warning: {
    icon: "warning" as const,
    content: (
      <div className="flex flex-col gap-1">
        <p className="map-style-banner-title">Map Key Color Limit Reached</p>
        <p className="map-style-banner-body">
          The Map Key can display a maximum of 7 colors. You can keep this color
          pin in the map, but it will not appear in the Map Key.
        </p>
      </div>
    ),
  },
  info: {
    icon: "info" as const,
    content: (
      <p className="map-style-banner-body">
        The Map Key can display a maximum of 7 colors. Keep this in mind when
        styling your property pins.
      </p>
    ),
  },
};

const MapStyleBanner = ({
  isWarning,
  selectedPinInfo,
}: {
  isWarning: boolean;
  selectedPinInfo?: SelectedPinInfo;
}) => {
  // Show styling message if selectedPinInfo is provided
  if (selectedPinInfo && selectedPinInfo.numbers.length > 0) {
    // Format numbers with IDs: "1 (id1) and 2 (id2)" or "1 (id1), 2 (id2) and 3 (id3)"
    const formatNumbersWithIds = (numbers: number[]) => {
      const pairs = numbers.map((num) => `${num}`);
      if (pairs.length === 1) return pairs[0];
      if (pairs.length === 2) return pairs.join(' and ');
      return pairs.slice(0, -1).join(', ') + ' and ' + pairs[pairs.length - 1];
    };

    return (
      <div className="map-style-banner info">
        <EmeraldIcon
          icon="info"
          type="filled"
          variant="icon"
          className="map-style-banner-icon"
        />
        <p className="map-style-banner-body">
          Styling {selectedPinInfo.type} {formatNumbersWithIds(selectedPinInfo.numbers)}
        </p>
      </div>
    );
  }

  // Otherwise show the default warning/info message
  const variant = isWarning ? "warning" : "info";
  const { icon, content } = bannerConfig[variant];

  return (
    <div className={`map-style-banner ${variant}`}>
      <EmeraldIcon
        icon={icon}
        type="filled"
        variant="icon"
        className="map-style-banner-icon"
      />
      {content}
    </div>
  );
};

export default MapStyleBanner;
